import { getEmployeeStorage, isSuperUserEmployee } from 'auth/local-storage';
import Helper from 'library/Helper';
import moment from 'moment';
import { last, isNil, isEmpty } from 'lodash';
import { transformInvoicesDetailNew } from '../consignment-helper';
import { formFields, dangerousGoodFields } from '../create-modal.constants';

export const isEmptyValue = (value: any) => isNil(value) || value === '';

export const convertToAPIBodySaveSingle = (updatedData?: any, options: Record<any, any> = {}) => {
    const {
        editData, showRiskSurchargeType, isCodFieldPresent,
        isCustomFieldAllowed, customFieldsList, sendCustomFieldObject,
    } = options;
    const pickupTime = updatedData?.pickupTime?.split('-');

    // Prioritize currentSlotData if available, otherwise use form values
    let deliveryDate = updatedData?.deliveryDate;
    let deliveryStartTime = updatedData?.deliveryTime?.[0];
    let deliveryEndTime = updatedData?.deliveryTime?.[1];

    if (options?.currentSlotData) {
        deliveryDate = options.currentSlotData.deliveryDate;
        deliveryStartTime = options.currentSlotData.timeSlot?.[0];
        deliveryEndTime = options.currentSlotData.timeSlot?.[1];
    }

    if (deliveryStartTime && moment.isMoment(deliveryStartTime)) {
        deliveryStartTime = deliveryStartTime.format('HH:mm:ss');
    }
    if (deliveryEndTime && moment.isMoment(deliveryEndTime)) {
        deliveryEndTime = deliveryEndTime.format('HH:mm:ss');
    }
    const shipmentPurpose = updatedData.courierType === 'non-document'
        ? updatedData.shipmentPurpose : updatedData.shipmentPurposeDoc;
    const isCOD = updatedData.isCOD === 'yes';
    const employee = getEmployeeStorage();
    const isSuperUser = isSuperUserEmployee();
    const source = options.source || (editData ? 'CUSTOMER_PORTAL_SINGLE_UPDATE' : undefined);
    let customFields: any = {};
    if (isCustomFieldAllowed || sendCustomFieldObject) {
        const customFieldsIds: string[] = customFieldsList?.map((item: any) => item.id);
        customFields = Object.entries(updatedData)
            .filter(([key]) => customFieldsIds?.includes(key))
            .map(([key, value]) => {
                return [key, value];
            });
    }
    if (customFields.length) {
        customFields = Object.fromEntries(customFields);
    }
    return {
        ...customFields,
        customFields: sendCustomFieldObject ? customFields : undefined,
        isBookedUsingV2: true,
        allPiecesWithSameDimensions: false,
        codAmount: !isCodFieldPresent || isCOD ? (updatedData.codAmount || undefined) : undefined,
        codCollectionMode: isCOD ? (updatedData.codCollectionMode || null) : null,
        codFavorOf: isCOD ? updatedData.codFavorOf : undefined,
        // sending last value, to get final selected commodity Id in Cascader
        commodityId: Helper.isValidArray(updatedData.commodityId) ? [last(updatedData.commodityId)] : undefined,
        currency: updatedData.currency,
        consignmentCategory: updatedData.consignmentCategory,
        consignmentType: updatedData.consignmentType,
        courierType: updatedData.courierType,
        customerReferenceNumber: updatedData.customerReferenceNumber,
        copAmount: updatedData.cashonpickup,
        isRetailTransaction: updatedData.retailTransactionType === 'retailTransactionTrue' || false,
        typeOfDelivery: updatedData.typeOfDelivery,
        description: updatedData.description,
        dimensions: {
            length: isEmptyValue(updatedData.length)
                ? null
                : Helper.converttoCentimeter(updatedData.length, updatedData.unit),
            width: isEmptyValue(updatedData.width)
                ? null
                : Helper.converttoCentimeter(updatedData.width, updatedData.unit),
            height: isEmptyValue(updatedData.height)
                ? null
                : Helper.converttoCentimeter(updatedData.height, updatedData.unit),
        },
        dstAddress: updatedData.dstAddress,
        ewayBill: updatedData.consignmentCategory === 'international'
            ? updatedData.ewayBillNumber : updatedData.ewayBill,
        kiranaHubCode: updatedData.kiranaHubCode,
        isFragile: false,
        isInternational: updatedData.consignmentCategory === 'international',
        isRiskSurchargeApplicable: updatedData.isRiskSurchargeApplicable,
        numberOfPieces: isEmptyValue(updatedData.numberOfPieces) ? null : Number(updatedData.numberOfPieces),
        // piecesDetail: apiBodyPieceDetails(updatedData.pieces, updatedData.courierType === 'document'),
        referenceNumber: updatedData.referenceNumber,
        retAddress: updatedData.retAddress,
        serviceType: updatedData.serviceType,
        srcAddress: updatedData.srcAddress,
        piecesDetail: updatedData?.piecesDetail,
        invoice_number_list: !isEmpty(updatedData.invoicesDetail)
            ? transformInvoicesDetailNew(updatedData.invoicesDetail) : '',
        weight: isEmptyValue(updatedData.weight)
            ? null
            : Helper.converttoKilogram(Number(updatedData.weight), updatedData.weightUnit),
        declaredPrice: updatedData.declaredValue,
        alternateDelAddress1: updatedData.alternateDelAddress1,
        alternateDelAddress2: updatedData.alternateDelAddress2,
        redirectionAddress: updatedData.redirectionAddress,
        childClient: updatedData.childClient ? {
            code: updatedData.childClient.split('+')[0],
            id: updatedData.childClient.split('+')[1],
        } : null,
        custSellerCode: updatedData.custSellerCode,
        shipmentPurpose,
        deliveryInstructions: updatedData.deliveryInstructions,
        deliveryInstruction: updatedData.deliveryInstruction,
        pickupInstruction: updatedData.pickupInstruction,
        eoriNumber: updatedData.eoriNumber,
        ioriNumber: updatedData.ioriNumber,
        freightCost: updatedData.freightCost,
        freightCostCurrency: updatedData.freightCostCurrency,
        againstBondLut: updatedData.againstBondLut,
        ecomShipment: updatedData.ecomShipment ? updatedData.ecomShipment === 'true' : undefined,
        meis: updatedData.meis ? updatedData.meis === 'true' : undefined,
        isBattery: updatedData.isBattery ? updatedData.isBattery === 'true' : undefined,
        exportInvoiceDate: updatedData?.invoiceDate?.format('YYYY-MM-DD'),
        fobValueCurrency: updatedData.fobValueCurrency,
        fobValue: updatedData.fobValue,
        totalGSTPaidCurrency: updatedData.totalGSTPaidCurrency,
        totalGSTPaidAmount: updatedData.totalGSTPaidAmount,
        consignorCompanyName: updatedData.consignorCompanyName,
        consignorTaxId: updatedData.consignorTaxId,
        consignorIECNumber: updatedData.consignorIECNumber,
        consignorGSTINNumber: updatedData.consignorGSTINNumber,
        consignorPanId: updatedData.consignorPanId,
        consignorKycDocType: updatedData.consignorKycDocType,
        consignorKycDocNumber: updatedData.consignorKycDocNumber,
        consignorKycFrontImage: updatedData.consignorKycFrontImage,
        consignorKycBackImage: updatedData.consignorKycBackImage,
        senderBankAccountNumber: updatedData.senderBankAccountNumber,
        senderBankADCode: updatedData.senderBankADCode,
        senderBankIFSCCode: updatedData.senderBankIFSCCode,
        nefiFlag: updatedData.nefiFlag ? updatedData.nefiFlag === 'true' : undefined,
        cpcCode: updatedData.cpcCode,
        cessValue: updatedData.cessValue,
        ewayBillNumber: updatedData.ewayBillNumber,
        invoiceType: updatedData.invoiceType,
        invoiceDate: updatedData?.invoiceDate?.format('YYYY-MM-DD'),
        invoiceNumber: updatedData.invoiceNumber,
        billAddress: updatedData.billToDetails,
        consigneeCompanyName: updatedData.consigneeCompanyName,
        incoTerms: updatedData.incoTerms,
        deliveryTerms: updatedData.deliveryTerms,
        originType: updatedData.originType,
        destinationType: updatedData.destinationType,
        // sending the dimenstion & weight data after converting api body
        dimensionUnit: 'cm',
        weightUnit: 'kg',
        receiverVATNumber: updatedData.receiverVATNumber,
        pickupDate: moment(updatedData.pickupSchedule).format('YYYY-MM-DD'),
        pickupTimeSlotStart: pickupTime ? pickupTime[0]?.trim() : undefined,
        pickupTimeSlotEnd: pickupTime ? pickupTime[1]?.trim() : undefined,
        pickupServiceTime: updatedData.pickupServiceTime,
        declaredCurrency: updatedData.declaredCurrency,
        unlistedCommodityName: updatedData?.unlistedCommodityName,
        ewbNumber: updatedData.ewbNumber,
        ewbDate: moment(updatedData.ewbDate).format('YYYY-MM-DD'),
        riskSurchargeType: showRiskSurchargeType
            ? updatedData.riskSurchargeType : null,
        consignmentFlowType: 'Standard',
        source,
        createdBy: isSuperUser ? `${employee?.employeeCode || ''} (Employee)`
            : `${updatedData.childClient?.split('+')[0] || ''} (Customer)`,
        invoiceAmount: updatedData.invoiceAmount,
        customsAmount: updatedData.customsAmount,
        importReferenceNumber: updatedData.importReferenceNumber,
        exportReferenceNumber: updatedData.exportReferenceNumber,
        purpose: updatedData.purpose,
        isCustomsDeclarable: updatedData.isCustomsDeclarable === 'true',
        consigneeCode: updatedData.consigneeCode,
        dangerousGoodAccessible: updatedData.dangerousGoodAccessible === 'true',
        isCsbv: updatedData.isCsbv,
        manufacturingCountry: updatedData.manufacturingCountry,
        taxPercentage: updatedData.taxDetailsTaxPercentage,
        totalTax: updatedData.taxDetailsTotalTax,
        dangerousGoodCategory: updatedData.dangerousGoodCategory,
        dangerousGoodCategoryPackingInstruction: updatedData.dangerousGoodCategoryPackingInstruction,
        dangerousGoodCategoryType: updatedData.dangerousGoodCategoryType,
        dangerousGoodClass: updatedData.dangerousGoodClass,
        dangerousGoodDivision: updatedData.dangerousGoodDivision,
        dangerousGoodName: updatedData.dangerousGoodName,
        dangerousGoodPackingGroup: updatedData.dangerousGoodPackingGroup,
        dangerousGoodUnNumber: updatedData.dangerousGoodUnNumber,
        isDangerousGood: updatedData.isDangerousGood === 'true',
        isStackable: updatedData.isStackable === 'yes',
        igst: updatedData.taxDetailsIgst,
        sgst: updatedData.taxDetailsSgst,
        cgst: updatedData.taxDetailsCgst,
        taxDetailsRecieverGstin: updatedData.taxDetailsRecieverGstin,
        taxDetailsSenderGstin: updatedData.taxDetailsSenderGstin,
        movementType: updatedData.movementType,
        forwardReferenceNumber: updatedData.forwardReferenceNumber,
        documentDetails: updatedData.documentDetails,
        productCode: updatedData.productCode,
        purchaseOrderNumber: updatedData.purchaseOrderNumber,
        notes: updatedData.notes,
        actionType: updatedData.actionType,
        deliveryDate: moment(deliveryDate).format('YYYY-MM-DD'),
        deliveryTimeSlotStart: deliveryStartTime
            ? moment(
                `${moment(deliveryDate).format('YYYY-MM-DD')} ${deliveryStartTime}`,
                'YYYY-MM-DD HH:mm:ss',
            ).unix()
            : undefined,
        deliveryTimeSlotEnd: deliveryEndTime
            ? moment(
                `${moment(deliveryDate).format('YYYY-MM-DD')} ${deliveryEndTime}`,
                'YYYY-MM-DD HH:mm:ss',
            ).unix()
            : undefined,
    };
};

export const internationalFields = [
    'custSellerCode',
    'shipmentPurposeDoc',
    'deliveryTerms',
    'deliveryInstructions',
    'eoriNumber',
    'againstBondLut',
    'ecomShipment',
    'meis',
    'isBattery',
    'receiverVATNumber',
    'consigneeCompanyName',
    'consignorCompanyName',
    'originType',
    'consignorIECNumber',
    'consignorGSTINNumber',
    'consignorPanId',
    'senderBankAccountNumber',
    'senderBankADCode',
    'senderBankIFSCCode',
    'nefiFlag',
    'cpcCode',
    'consignorKycDocType',
    'consignorKycDocNumber',
    'consignorKycFrontImage',
    'consignorKycBackImage',
    'ewayBillNumber',
    'invoiceType',
    'ewbNumber',
    'type',
    'ewayBillDownloadDeclaration',
    'transaction',
    'reasonTransport',
    'transMode',
    'transDistance',
    'documentType',
    'sendername',
    'senderaddressLine1',
    'senderaddressLine2',
    'senderpincode',
    'sendercityName',
    'senderstateName',
    'sendercountryName',
    'senderphone',
    'recievername',
    'recieveraddressLine1',
    'recieveraddressLine2',
    'recieverpincode',
    'recievercityName',
    'recieverstateName',
    'recievercountryName',
    'recieverphone',
    'senderGstin',
    'recieverGstin',
    'prodName',
    'hsnCode',
    'ewayBillDescription',
    'quantity',
    'unit',
    'totalValue',
    'cgstValue',
    'igstValue',
    'sgstValue',
    'cessValue',
    'freightCost',
    'fobValue',
    'totalGSTPaidAmount',
    'boxDetails',
    'importConsignorDataControl',
    'destinationType',
];

export const domesticFields = [
    'isCOD',
    'codAmount',
    'codCollectionMode',
    'codFavorOf',
];

export const nonDocumentFields = [
    'non_document',
    'boxDetails',
];

export const customFormSummaryStepNecessaryFields = [
    'ewbNumber',
    'ewayBillNumber',
];

export const getPiecesDetail = (data: any, piecesData: any[] = [], manufacturingCountryList: any[] = []) => {
    const {
        Length,
        Width,
        Height,
        Unit,
        Weight,
        WeightUnit,
        ItemUnitType,
        Amount,
        Quantity,
        Description,
        ReferenceNumber,
        PurchaseOrderNumber,
        Eccn,
        PieceProductCode,
        HsCode,
        IossCode,
        IsKit,
        ManufacturingCountry,
        ForwardReferenceNumber,
        ProductCategory,
        ProductFamily,
        BrandName,
        DeclaredValue,
        DeclaredValueCurrency,
        TotalTax,
        TaxPercentage,
        MEIS,
        IGST,
        SGST,
        CGST,
        TaxDetailsRecieverGstin,
        TaxDetailsSenderGstin,
    } = formFields;

    const {
        IsDangerousGood,
        DangerousGoodAccessible,
        DangerousGoodUnNumber,
        DangerousGoodClass,
        DangerousGoodName,
        DangerousGoodDivision,
        DangerousGoodPackingGroup,
        DangerousGoodCategory,
        DangerousGoodCategoryType,
        DangerousGoodCategoryPackingInstruction,
    } = dangerousGoodFields;

    const piecesDetail = [];
    for (let i = 0; i < piecesData.length; i += 1) { // add each key to validationBuilderFieldMapping
        piecesDetail.push({
            reference_number: data[`piece_${ReferenceNumber.key}_${i}`],
            description: data[`piece_${Description.key}_${i}`],
            length: data[`piece_${Length.key}_${i}`],
            width: data[`piece_${Width.key}_${i}`],
            weight: data[`piece_${Weight.key}_${i}`],
            height: data[`piece_${Height.key}_${i}`],
            unit: data[`piece_${Unit.key}_${i}`],
            weightUnit: data[`piece_${WeightUnit.key}_${i}`],
            quantity: data[`piece_${Quantity.key}_${i}`],
            codAmount: data[`piece_${Amount.key}_${i}`],
            purchaseOrderNumber: data[`piece_${PurchaseOrderNumber.key}_${i}`],
            eccn: data[`piece_${Eccn.key}_${i}`],
            isKit: data[`piece_${IsKit.key}_${i}`] === 'yes',
            hsCode: data[`piece_${HsCode.key}_${i}`],
            hsnCode: data[`piece_${HsCode.key}_${i}`],
            iossNumber: data[`piece_${IossCode.key}_${i}`],
            pieceProductCode: data[`piece_${PieceProductCode.key}_${i}`],
            manufacturingCountry: data[`piece_${ManufacturingCountry.key}_${i}`],
            isDangerousGood: data[`piece_${IsDangerousGood.key}_${i}`] === 'true',
            dangerousGoodAccessible: data[`piece_${DangerousGoodAccessible.key}_${i}`] === 'true',
            dangerousGoodUnNumber: data[`piece_${DangerousGoodUnNumber.key}_${i}`],
            dangerousGoodClass: data[`piece_${DangerousGoodClass.key}_${i}`],
            dangerousGoodName: data[`piece_${DangerousGoodName.key}_${i}`],
            dangerousGoodDivision: data[`piece_${DangerousGoodDivision.key}_${i}`],
            dangerousGoodPackingGroup: data[`piece_${DangerousGoodPackingGroup.key}_${i}`],
            dangerousGoodCategory: data[`piece_${DangerousGoodCategory.key}_${i}`],
            dangerousGoodCategoryType: data[`piece_${DangerousGoodCategoryType.key}_${i}`],
            dangerousGoodCategoryPackingInstruction: data[`piece_${DangerousGoodCategoryPackingInstruction.key}_${i}`],
            declaredValue: data[`piece_${DeclaredValue.key}_${i}`],
            declaredCurrency: data[`piece_${DeclaredValueCurrency.key}_${i}`],
            totalTax: data[`piece_${TotalTax.key}_${i}`],
            taxPercentage: data[`piece_${TaxPercentage.key}_${i}`],
            meisApplicable: data[`piece_${MEIS.key}_${i}`],
            itemUnit: data[`piece_${ItemUnitType.key}_${i}`],
            manufacturingCountryName: manufacturingCountryList
                ?.find((country: any) => country.value === data[`piece_${ManufacturingCountry.key}_${i}`])?.label,
            igst: data[`piece_${IGST.key}_${i}`],
            sgst: data[`piece_${SGST.key}_${i}`],
            cgst: data[`piece_${CGST.key}_${i}`],
            taxDetailsRecieverGstin: data[`piece_${TaxDetailsRecieverGstin.key}_${i}`],
            taxDetailsSenderGstin: data[`piece_${TaxDetailsSenderGstin.key}_${i}`],
            forwardReferenceNumber: data[`piece_${ForwardReferenceNumber.key}_${i}`],
            productCategory: data[`piece_${ProductCategory.key}_${i}`],
            productFamily: data[`piece_${ProductFamily.key}_${i}`],
            brandName: data[`piece_${BrandName.key}_${i}`],
        });
    }
    return piecesDetail;
};

export const getInvoicesDetail = (data: any, invoicesData: any[] = []) => {
    const {
        ReferenceNumber,
        InvoiceNumber,
        InvoiceStatus,
        InvoiceDate,
        InvoiceAmount,
        EwbNumber,
        SenderGstin,
        ReceiverGstin,
        EwbCreationTime,
        EwbExpiryTime,
        TransporterGstin,
        TransporterName,
        ProofImageList,
    } = formFields;

    const invoicesDetail = [];
    for (let i = 0; i < invoicesData.length; i += 1) {
        invoicesDetail.push({
            reference_number: data[`invoice_${ReferenceNumber.key}_${i}`],
            invoiceNumber: data[`invoice_${InvoiceNumber.key}_${i}`],
            invoiceStatus: data[`invoice_${InvoiceStatus.key}_${i}`],
            invoiceDate: data[`invoice_${InvoiceDate.key}_${i}`],
            invoiceAmount: data[`invoice_${InvoiceAmount.key}_${i}`],
            ewbNumber: data[`invoice_${EwbNumber.key}_${i}`],
            senderGstin: data[`invoice_${SenderGstin.key}_${i}`],
            receiverGstin: data[`invoice_${ReceiverGstin.key}_${i}`],
            ewbCreationTime: data[`invoice_${EwbCreationTime.key}_${i}`],
            ewbExpiryTime: data[`invoice_${EwbExpiryTime.key}_${i}`],
            transporterGstin: data[`invoice_${TransporterGstin.key}_${i}`],
            transporterName: data[`invoice_${TransporterName.key}_${i}`],
            proofImageList: data[`invoice_${ProofImageList.key}_${i}`],
        });
    }
    return invoicesDetail;
};

export const getChildClientFallback = (existingChildClient?: string): { childClient?: string } => {
    if (existingChildClient) return {};
    const customerCode = window.localStorage.getItem('childCustomerCode') || undefined;
    const customerId = window.localStorage.getItem('childCustomerId') || undefined;
    return { childClient: `${customerCode}+${customerId}` };
};
